import type { ClientGeoArea } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useSharedAppApi } from '@/features/api/hooks/shared-app/useSharedAppApi';
import { getLeafs } from '@/features/geo-area/utils/geoArea';
import { isEmptyOrNull } from '@/shared/utils/string';

export const useSearchAvailableGeoAreas = (search: string = '') => {
  const api = useSharedAppApi();

  const handleSelect = useCallback(
    (geoAreas: readonly ClientGeoArea[]) => getLeafs(geoAreas),
    []
  );

  return useQuery({
    queryKey: [API_CACHE_KEYS.SEARCH_AVAILABLE_GEO_AREAS, { search }],
    queryFn: () =>
      api.searchAvailableGeoAreasForAppVariant({
        search,
        includeAllChildrenOfMatchingAreas: true
      }),
    enabled: !isEmptyOrNull(search) && search.length > 2,
    select: handleSelect
  });
};
